import { jsx as _jsx } from "react/jsx-runtime";
import { _className, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './QLoader.scss';
/**
 * @category Components
 */
export class QLoader extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return;
    }
    render() {
        const className = _className('spinner', this.props.type || 'basic');
        return _jsx("div", { className: 'qloader', children: _jsx("div", { className: className }) });
    }
}
//# sourceMappingURL=QLoader.js.map